// src/pages/Login.jsx  ← 전체 교체본 (필요 부분만 수정)
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api";
import styles from "./Login.module.css";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  // 로그인 후 돌아갈 곳 (보호 라우트에서 온 경우)
  const from = location.state?.from?.pathname || "/dashboard";

  // --- 폼 상태 ---
  const [userId, setUserId] = useState("");
  const [userPw, setUserPw] = useState("");
  const [rememberId, setRememberId] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // 저장된 아이디 불러오기
  useEffect(() => {
    const saved = localStorage.getItem("loginSavedId");
    if (saved) {
      setUserId(saved);
      setRememberId(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const username = (userId || "").trim();
    const password = userPw || "";

    if (!username || !password) {
      setErrorMsg("아이디와 비밀번호를 입력하세요.");
      return;
    }

    setLoading(true);
    try {
      // ★ 수정: '/token/' → 'auth/login/' (앞 슬래시 제거)
      // baseURL이 .../api/ 로 끝나므로 최종 URL은 https://gcjoberp.com/api/auth/login/
      const res = await api.post("auth/login/", { username, password });

      const { access, refresh } = res.data || {};
      if (!access || !refresh) throw new Error("토큰 응답이 올바르지 않습니다.");

      // 토큰 저장
      localStorage.setItem("accessToken", access);
      localStorage.setItem("refreshToken", refresh);

      // 다음 요청부터 바로 반영(선택)
      api.defaults.headers.common["Authorization"] = `Bearer ${access}`;

      
      // ✅ 유저 정보 저장 (권한 판단용)
      const meRes = await api.get("auth/me/");
      localStorage.setItem("user", JSON.stringify(meRes.data));
      
      // 아이디 저장 옵션 처리
      if (rememberId) localStorage.setItem("loginSavedId", username);
      else localStorage.removeItem("loginSavedId");

      // 대시보드로 이동
      navigate(from, { replace: true });
    } catch (err) {
      // 서버 메시지 우선 노출
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.message ||
        "로그인을 실패했습니다. 아이디 또는 비밀번호를 확인하세요.";
      setErrorMsg(String(msg));
      // 디버깅 로그
      console.error("LOGIN ERROR:", err?.response || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.siteHeader}>
        <span className={styles.ciLogo}>금천일자리주식회사</span>
      </header>

      <div className={styles.loginContainer}>
        <div className={styles.loginBox}>
          <h2>로그인</h2>
          <p className={styles.description}>
            금천일자리주식회사 내부망 ERP 프로그램입니다.
          </p>

          <form id="loginForm" onSubmit={handleSubmit} autoComplete="on">
            <input
              type="text"
              id="userId"
              placeholder="아이디를 입력하세요."
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
              autoComplete="username"
            />
            <input
              type="password"
              id="userPw"
              placeholder="비밀번호를 입력하세요."
              value={userPw}
              onChange={(e) => setUserPw(e.target.value)}
              required
              autoComplete="current-password"
            />

            <div className={styles.options}>
              <label className={styles.saveId}>
                <input
                  type="checkbox"
                  checked={rememberId}
                  onChange={(e) => setRememberId(e.target.checked)}
                />
                <span>아이디 저장</span>
              </label>
            </div>

            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? "로그인 중..." : "로그인"}
            </button>

            {errorMsg && (
              <p id="errorMsg" className={styles.error}>
                {errorMsg}
              </p>
            )}
          </form>

          <div className={styles.links}>
            <a href="#">아이디 찾기</a>
            <a href="#">비밀번호 찾기</a>
            <a href="/signup">회원가입</a>
          </div>
        </div>
      </div>
    </div>
  );
}
